export enum RecalculatePriceMode {
  Both = "Both",
  SupplierPriceRatesOnly = "SupplierPriceRatesOnly",
  ClientPriceRatesOnly = "ClientPriceRatesOnly",
}
